export class GatewayPayment {
  amount: number;
  fromLocationCode: number;
  paymentType: string;
  gatewayPaymentResponseCode: number;
}
